module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Card_Poster-45d61357b24fce998bd704f5a6310463.jpg";